import { Component } from '@angular/core';

@Component({
  selector: 'cap-pbi-reports-list',
  templateUrl: './reports-list.component.html',
  styleUrls: ['./reports-list.component.scss'],
})
export class CapturumPowerBIReportsListComponent {
}
